import { combineReducers, Reducer } from 'redux';
import { WidgetActionType } from '../actions';
import { WidgetLoadSharedConfigsAction } from './actions';
import {
    initialWidgetsSharedConfigState,
    WidgetsSharedConfigState,
} from 'widgets/store/sharedConfiguration/WidgetsSharedConfigState';
import { portfolioSummarySharedConfigurationReducer } from 'widgets/portfolioSummary/store/sharedConfiguration/reducer';

export const combinedWidgetsSharedConfigReducer =
    combineReducers<WidgetsSharedConfigState>({
        portfolioSummary: portfolioSummarySharedConfigurationReducer,
    });

export const widgetsSharedConfigReducer: Reducer<
    WidgetsSharedConfigState,
    WidgetLoadSharedConfigsAction
> = (state, action) => {
    if (action.type === WidgetActionType.WIDGET_LOAD_SHARED_CONFIGS) {
        return action.payload ?? initialWidgetsSharedConfigState;
    }

    return combinedWidgetsSharedConfigReducer(state, action)!;
};
